import React from 'react';
import { BoxProps, Flex } from '@withjoy/joykit';
import { DistanceFromVenue } from '@shared/components/DistanceFromVenue';
import { DistanceStatistics } from './DistanceStatistics';
import { TravelDistancesBetweenPointsResponseFragment } from '@graphql/generated';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';

interface VenueAndTravelDistanceProps extends BoxProps {
  distances?: Maybe<TravelDistancesBetweenPointsResponseFragment>;
  milesToVenue?: number | null;
  useShortWordingDistance?: boolean;
}

export const VenueAndTravelDistance = ({ distances, milesToVenue, useShortWordingDistance, ...props }: VenueAndTravelDistanceProps) => {
  const [accommodationGuestHotelTileFontUpdatesEnabled] = useIsFeatureEnabled('accommodationGuestHotelTileFontUpdates');
  return (
    <Flex
      gap={4}
      alignItems="center"
      marginTop={1}
      {...props}
    >
      <DistanceFromVenue
        distances={distances}
        milesToVenue={milesToVenue}
        color={accommodationGuestHotelTileFontUpdatesEnabled ? 'mono10' : 'mono14'}
        {...(accommodationGuestHotelTileFontUpdatesEnabled && { size: 'sm' })}
        useToWording
        useShortWording={useShortWordingDistance}
      />
      <DistanceStatistics
        distances={distances}
        milesToVenue={milesToVenue}
        useShortWording
        {...props}
      />
    </Flex>
  );
};
